// Seeded purple field used as a card cover until real artwork exists.
// Ported from the hand-built articles.html design.
const SERIES_LABEL = {
  "After Issuance": 'After <i>issuance</i>',
  "Tokenization Digest": 'Tokenization <i>Digest</i>',
  Partners: 'In <i>partnership</i>',
  Perspectives: '<i>Perspectives</i>',
};

export function genCoverStyle(title) {
  const seed = [...String(title)].reduce((s, c) => s + c.charCodeAt(0), 0);
  const r = (n) => ((seed * 9301 + 49297 * n) % 233280) / 233280;
  const hues = [[76, 55, 120], [91, 63, 134], [42, 28, 74], [30, 22, 58]];
  const g = hues
    .map((h, i) => `radial-gradient(55% 75% at ${8 + r(i + 1) * 84}% ${r(i + 5) * 100}%, rgba(${h},${0.8 - i * 0.12}) 0%, rgba(${h},0) 64%)`)
    .join(",");
  return `${g},#15102A`;
}

export function seriesLabel(category, partner) {
  if (partner) return `With ${partner}`;
  return SERIES_LABEL[category] || category || "T-REX";
}
